export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  color: string;
  imageSeq: string;
}

export const categories: Category[] = [
  {
    slug: 'plot-analysis',
    name: '剧情解析',
    description: '深入解读初音岛系列各作品的剧情脉络、世界观设定与隐藏伏笔，带你领略樱花树下的动人故事。',
    icon: 'ri-book-open-line',
    color: 'primary',
    imageSeq: 'cat-plot',
  },
  {
    slug: 'characters',
    name: '角色介绍',
    description: '详细介绍初音岛中每一位登场的魅力角色，剖析性格特点、成长轨迹与经典台词。',
    icon: 'ri-user-heart-line',
    color: 'accent',
    imageSeq: 'cat-chars',
  },
  {
    slug: 'guides',
    name: '游戏攻略',
    description: '提供全系列通关路线指南、隐藏剧情触发条件、全CG收集攻略等实用内容。',
    icon: 'ri-guide-line',
    color: 'secondary',
    imageSeq: 'cat-guides',
  },
  {
    slug: 'merchandise',
    name: '周边资讯',
    description: '汇总初音岛系列最新周边商品情报、限定手办收藏指南与官方画集推荐。',
    icon: 'ri-gift-line',
    color: 'accent',
    imageSeq: 'cat-merch',
  },
  {
    slug: 'community',
    name: '粉丝社区',
    description: '汇聚全球初音岛粉丝的同人创作、Cosplay作品与线下活动纪实，共建温暖社区。',
    icon: 'ri-group-line',
    color: 'primary',
    imageSeq: 'cat-community',
  },
];